import React, { useState, useRef } from 'react';
import { noWebapp, onlyHaveWebapp } from 'config/CustomEnums';
export const getContentTips = () => {

    return (
        <ul className='content-tips'>
            {
                !noWebapp ? (
                    <li>
                        {("Insert campaign URL for web\n" +
                            "When customer click on the link, will open the page in website and " +
                            "show a banner for customer to open the same content in native " +
                            "app, redirect to app store if the native app has not been installed.")}
                    </li>
                ) : null
            }
            {
                !onlyHaveWebapp ? (
                    <li>
                        {"Insert campaign deep link for app\n" +
                            "When customer click on the link, will redirect to native app if the" +
                            "app has been installed;  if not installed, will show a page to app" +
                            "store."}
                    </li>
                ) : null
            }
        </ul>
    )
}